/**
 * 遮罩手機號碼：只顯示「前 2 碼 + 後 3 碼」，中間以全形星號（＊）遮罩。
 * 例：0912345678 → 09＊＊＊＊＊678
 *
 * ⚠️ 使用範圍限定：只准用在「使用者本人自己輸入 / 本人 session 已知」的號碼，
 * 用途是回顯（例：「驗證碼已發送至 09＊＊＊＊＊678」）。這種號碼從未離開瀏覽器，
 * 後端沒有對應值可遮，故由前端處理。
 *
 * ❌ 絕不可用在「別人的資料」。任何來自 API 的他人號碼/姓名/地址一律吃後端已遮罩欄位
 *    （phone_masked / address_masked，見 lpg-app-api；姓名一律不回前端，
 *     見 onboarding 隱私原則：比對到既有客戶時連遮罩姓名都不送）
 *     src/modules/onboarding/onboarding-mask.util.ts），前端不得自行遮罩，
 *    以免明碼一度進到前端。
 *
 * 遮罩規則與後端 maskPhone() 保持一致，兩邊改動需同步。
 * 輸入欄位不套用（需要完整號碼）。
 * 少於 5 碼（無法保留前2後3）→ 原樣回傳，避免產出誤導字串。
 */
export const maskPhone = (p?: string): string => {
  const d = (p || "").replace(/\D/g, "");
  if (d.length < 5) return p || "";
  return d.slice(0, 2) + "＊".repeat(d.length - 5) + d.slice(-3);
};
